import ErrorComponent from "@/components/atoms/ErrorComponent";
import CourseHeader from "@/components/molecules/card-headers/courses/CourseHeader";
import CourseEditCard from "@/components/molecules/cards/courses/CourseEditCard";
import { UUID_REGEX } from "@/constants/regexs";
import { FC } from "react";
import { useParams } from "react-router-dom";

const CourseEditView: FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id || !UUID_REGEX.test(id)) {
    return (
      <ErrorComponent error={{ status: 404, data: {} }} absolute returnButton />
    );
  }

  return (
    <div className="formalys-page formalys-detail-page formalys-edit-page">
      <CourseHeader id={id} isEdit />
      <CourseEditCard id={id} />
    </div>
  );
};

export default CourseEditView;
